import { styled } from 'styled-components';
import { Theme, Utils } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

interface IAvatarSignProps {
  $displayText?: boolean;
  $styleType?: 'formUniversal' | 'modal';
}

export const ImageDetailsContainerStyled = styled.div`
  ${flexFn('center', 'center', 'column')}
  gap: ${pxToRem(10)};
`;

export const AvatarSignStyled = styled.div<IAvatarSignProps>`
  background-color: ${({ $styleType }) =>
    $styleType === 'formUniversal'
      ? Theme.colors.greyShades.grey5
      : Theme.colors.greyShades.grey13};
  color: ${({ $styleType }) =>
    $styleType === 'formUniversal'
      ? Theme.colors.greyShades.grey13
      : Theme.colors.greyShades.grey5};
  font-size: ${pxToRem(12)};
  padding: ${pxToRem([4, 6])};
  border-radius: ${pxToRem(3)};
  visibility: ${({ $displayText }) => ($displayText ? 'visible' : 'hidden')};
`;

export const AvatarBorderStyled = styled.div`
  height: ${pxToRem(95)};
  width: ${pxToRem(1)};
  border-left: ${pxToRem(1)} dotted ${Theme.colors.greyShades.grey13};
  margin: ${pxToRem([0, 20, 0, 20])};
  align-self: flex-start;
`;
